import { getNs } from 'common/i18n-config'
import { OperationLog } from 'common/models'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import { useSelector } from 'react-redux'
import { selectMasterData } from 'store/masterData/selectors'

import { OperationLogTarget, OperationLogType } from '../constant'

const { t, useNsReady } = getNs(['components/organisms/internal-control/log-list-item-detail'])

export const useTargetName = (logItem: OperationLog) => {
  useNsReady()

  const masterData = useSelector(selectMasterData, isEqual)
  const targetName = find(masterData.operation_target, item => item.code === logItem?.target)?.name_jp

  const isAccelerated = logItem?.target === OperationLogTarget.ACCELERATED_EVENT
  const isRegisterAccelerated = isAccelerated && logItem?.type === OperationLogType.REGISTRATION
  const isCorrectAccelerated = isAccelerated && logItem?.type === OperationLogType.UPDATE
  const isCancelAccelerated = isAccelerated && logItem?.type === OperationLogType.REMOVE

  if (!isAccelerated) return targetName
  if (isRegisterAccelerated) return t('accelerated_depreciation_register')
  if (isCorrectAccelerated) return t('accelerated_depreciation_correction')
  if (isCancelAccelerated) return t('accelerated_depreciation_cancel')
}
